import {useHistory} from "react-router-dom";
import {useEffect, useState} from "react";
import {Button, Card, Space, Table} from "antd";
import {t} from "i18next";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import ApiService from "../../core/service/ApiService";
import { FilterActions, SearchCard } from "../../core/components/quick-filter/QuickFilterParts";
import { matchesSearch } from "../../core/utils/text-search";
import AppLink from "../../core/components/AppLink";

export default function CashRegisterList()
{
    const history = useHistory();
    const [cashRegister, setCashRegister] = useState([]);
    const [search, setSearch] = useState('')

    const getCashRegisters = async () => {
        const res = await ApiService.CashRegister.GetCashRegisters(true)

        if(res.success)
        {
            setCashRegister(res.data)
        }
    }

    useEffect(() => {
        getCashRegisters()
    }, [])

    const filteredData = search
        ? cashRegister.filter(x => matchesSearch(x.name, search) || matchesSearch(x?.firm?.name, search))
        : cashRegister

    return (
        <SimpleLayout fullWidth={true}>
            <div className="qf-row qf-row-top">
                <SearchCard value={search} onChange={setSearch} />
            </div>
            <FilterActions>
                <Button size={'small'} onClick={() => {history.push(`/app/system/cash-registers/create`)}} type={'primary'}>{t('New')}</Button>
                <Button size={'small'} onClick={getCashRegisters}>{t('Refresh')}</Button>
            </FilterActions>
            <Card>
                <Table
                    size={'small'}
                    dataSource={filteredData}
                    pagination={false}
                    columns={[
                        {dataIndex: 'firm', key: 'firm', title: t('Firm'), render: (text, row) => `${row?.firm?.name}`},
                        {dataIndex: 'name', key: 'name', title: t('Name'), render: (text, row) => `${row?.name}`},
                        {dataIndex: '#', key: '#', title: t('#'), render: (text, row) => (
                                <Space>
                                    <AppLink key="edit" to={`/app/system/cash-registers/${row.id}/edit`}>{t('edit')}</AppLink>
                                </Space>
                            )},
                    ]}
                />
            </Card>
        </SimpleLayout>
    )
}